/* ============================================================
   ww-reviews.js - reads the ReviewsOnMyWebsite widget and re-draws its reviews in our own cards,
   newest first (snippets/ww-reviews.liquid).

   How: when the block scrolls into view, the widget script is loaded into a hidden mount. Once it has
   rendered, each review is found by its date (the one thing every review card carries), then the
   author, star count, text and avatar are read from that card. Names of the widget's CSS classes are
   never relied on, so a widget update shouldn't break this. If nothing can be read within ~10 s, the
   widget is shown as-is so the page is never left without reviews.
   The headline count and rating come from the block's settings; if the widget also prints a rating
   or a review count, those numbers win (that's the "dynamic" part).
   ============================================================ */
(function () {
  'use strict';
  if (window.__wwReviews) return;
  window.__wwReviews = true;

  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, sept: 8, oct: 9, nov: 10, dec: 11,
                 janv: 0, 'févr': 1, fevr: 1, mars: 2, avr: 3, mai: 4, juin: 5, juil: 6, 'août': 7, aout: 7, 'déc': 11 };
  var DATE_RX = /^\s*(?:(\d{1,2})\s+)?([A-Za-zéû]{3,5})\.?\s+(\d{1,2})?,?\s*(\d{4})\s*$/;

  function parseDate(s) {
    s = String(s || '').trim();
    var m = s.match(DATE_RX);
    if (m) {
      var mon = MONTHS[m[2].toLowerCase().replace(/\.$/, '')];
      var day = parseInt(m[1] || m[3] || '1', 10);
      if (mon != null) return new Date(parseInt(m[4], 10), mon, day);
    }
    var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return new Date(+iso[1], +iso[2] - 1, +iso[3]);
    return null;
  }

  function leaves(root) {
    var out = [], w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) { if (n.textContent.trim()) out.push(n); }
    return out;
  }

  function extract(root) {
    var dates = [];
    leaves(root).forEach(function (n) {
      var d = parseDate(n.textContent);
      if (d && !isNaN(d)) dates.push({ node: n.parentElement, date: d });
    });
    if (!dates.length) return [];

    /* the review card = the biggest ancestor of a date that holds only that one date */
    var all = dates.map(function (x) { return x.node; });
    function cardOf(el) {
      var card = el;
      for (var p = el.parentElement; p && p !== root; p = p.parentElement) {
        var count = 0;
        for (var i = 0; i < all.length; i++) if (p.contains(all[i])) count++;
        if (count > 1) break;
        card = p;
      }
      return card;
    }

    var seen = [], reviews = [];
    dates.forEach(function (x) {
      var card = cardOf(x.node);
      if (seen.indexOf(card) > -1) return;
      seen.push(card);

      var name = '', text = '', avatar = '', stars = 0;
      var texts = leaves(card).map(function (n) { return { el: n.parentElement, t: n.textContent.trim() }; })
        .filter(function (o) { return o.el !== x.node && !parseDate(o.t) && !/^(read more|lire la suite|voir plus|more|\.\.\.)$/i.test(o.t); });

      /* author: short bold-ish text; review: the longest block */
      texts.forEach(function (o) {
        var w = parseInt(getComputedStyle(o.el).fontWeight, 10) || 400;
        if (!name && o.t.length <= 40 && (w >= 600 || /^(h[1-6]|strong|b)$/i.test(o.el.tagName))) name = o.t;
      });
      texts.forEach(function (o) { if (o.t !== name && o.t.length > text.length) text = o.t; });
      if (!name) { texts.some(function (o) { if (o.t.length <= 40 && o.t !== text) { name = o.t; return true; } }); }

      /* stars: filled star icons, else any aria-label "N star", else 5 */
      var starEls = card.querySelectorAll('[class*="star"], [aria-label*="star" i], [title*="star" i]');
      var filled = 0, total = 0;
      for (var i = 0; i < starEls.length; i++) {
        var el = starEls[i], cls = String(el.className && el.className.baseVal != null ? el.className.baseVal : el.className || '');
        var lbl = (el.getAttribute('aria-label') || el.getAttribute('title') || '');
        var mm = lbl.match(/(\d(?:[.,]\d)?)\s*(?:\/\s*5\s*)?(?:star|étoile)/i);
        if (mm) { stars = Math.round(parseFloat(mm[1].replace(',', '.'))); break; }
        if (el.children.length && el.querySelector('[class*="star"]')) continue;     /* container, not an icon */
        total++;
        if (/full|fill|active|checked|on\b|selected/i.test(cls) || (getComputedStyle(el).color || '').match(/rgb\((2[0-9]{2}|1[89][0-9]), (1[0-9]{2}|[0-9]{2}), /)) filled++;
      }
      if (!stars) stars = filled ? Math.min(5, filled) : (total >= 5 ? 5 : 5);

      var imgs = card.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) {
        var src = imgs[k].currentSrc || imgs[k].src || '';
        if (/google|logo|facebook|badge|icon/i.test(src) || imgs[k].width < 20) continue;
        avatar = src; break;
      }
      if (text) reviews.push({ name: name || '', date: x.date, text: text, stars: stars, avatar: avatar });
    });

    reviews.sort(function (a, b) { return b.date - a.date; });
    return reviews;
  }

  /* Collect all text under a node, diving into shadow roots too (some widgets render in one). */
  function allText(root) {
    var out = [];
    (function walk(n) {
      if (!n) return;
      if (n.nodeType === 3) { var t = n.textContent.trim(); if (t) out.push(t); return; }
      if (n.shadowRoot) walk(n.shadowRoot);
      [].forEach.call(n.childNodes || [], walk);
      /* aria-labels / titles often carry "4.8 out of 5" or "2,153 reviews" */
      if (n.getAttribute) { var a = n.getAttribute('aria-label') || n.getAttribute('title'); if (a) out.push(a); }
    })(root);
    return out;
  }
  function readSummary(root) {
    var out = {};
    allText(root).forEach(function (t) {
      var r = t.match(/(?:^|\s)([0-4][.,]\d|5[.,]0|5)(?:\s*\/\s*5|\s*(?:out of|sur)\s*5|\s*(?:stars?|étoiles?)|$)/i);
      if (r && !out.rating) out.rating = parseFloat(r[1].replace(',', '.'));
      var c = t.match(/(\d{1,3}(?:[,\s.]\d{3})+|\d{2,6})\s*\+?\s*(?:google\s*|customer\s*|client\s*)?(reviews?|avis|évaluations?|ratings?|notes?)\b/i)
           || t.match(/(?:based on|basé(?:e)? sur|from|sur)\s*(\d{1,3}(?:[,\s.]\d{3})+|\d{2,6})/i);
      if (c && !out.total) { var n = parseInt(c[1].replace(/[,\s.]/g, ''), 10); if (n >= 10) out.total = n; }
    });
    return out;
  }
  var DEBUG = /[?&]ww_reviews_debug=1/.test(location.search);
  function debug(mount, sum) {
    if (!DEBUG) return;
    try {
      console.group('[ww-reviews] widget text');
      console.log(allText(mount).join(' | ').slice(0, 4000));
      console.log('summary read →', sum);
      console.log('cache →', readCache());
      console.groupEnd();
    } catch (e) {}
  }

  function star(on) {
    return '<svg viewBox="0 0 20 20" class="' + (on ? '' : 'is-off') + '" aria-hidden="true"><path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"/></svg>';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render(block, reviews, fr) {
    var track = block.querySelector('[data-rv-track]');
    var fmt = new Intl.DateTimeFormat(fr ? 'fr-CA' : 'en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
    track.innerHTML = reviews.map(function (r) {
      var s = ''; for (var i = 1; i <= 5; i++) s += star(i <= r.stars);
      var initial = (r.name || '?').trim().charAt(0).toUpperCase();
      var av = r.avatar ? '<img class="ww-rv__avatar" src="' + esc(r.avatar) + '" alt="" loading="lazy">' : '<span class="ww-rv__avatar" aria-hidden="true">' + esc(initial) + '</span>';
      var long = r.text.length > 260;
      return '<article class="ww-rv__card">' +
        '<div class="ww-rv__card-stars" aria-label="' + r.stars + '/5">' + s + '</div>' +
        '<p class="ww-rv__text' + (long ? ' is-clamped' : '') + '">' + esc(r.text) + '</p>' +
        (long ? '<button type="button" class="ww-rv__more" data-rv-more>' + (fr ? 'Lire la suite' : 'Read more') + '</button>' : '') +
        '<div class="ww-rv__meta">' + av + '<span class="ww-rv__who"><b>' + esc(r.name) + '</b><span>' + esc(fmt.format(r.date)) + '</span></span><span class="ww-rv__src">Google</span></div>' +
        '</article>';
    }).join('');

    track.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rv-more]');
      if (!b) return;
      var p = b.previousElementSibling; p.classList.toggle('is-clamped');
      b.textContent = p.classList.contains('is-clamped') ? (fr ? 'Lire la suite' : 'Read more') : (fr ? 'Réduire' : 'Show less');
    });

    var prev = block.querySelector('[data-rv-prev]'), next = block.querySelector('[data-rv-next]');
    function step() { var c = track.querySelector('.ww-rv__card'); return c ? c.getBoundingClientRect().width + 14 : 340; }
    function sync() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
    });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---- Dynamic totals (2026-09-24): the count the widget prints wins over the numbers typed into the
     section settings, is cached for a week, and is pushed into every place that shows it: the block
     headline, the "from N Google reviews" line, the PDP tab label (.ww-tabs__count / __score) and any
     [data-ww-review-count] / [data-ww-review-rating] element elsewhere in the theme. */
  var CACHE_KEY = 'wwReviewsSummary', CACHE_TTL = 7 * 24 * 3600 * 1000;
  function readCache() {
    try { var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null'); return c && (Date.now() - c.ts) < CACHE_TTL ? c : null; } catch (e) { return null; }
  }
  function writeCache(s) { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ rating: s.rating || null, total: s.total || null, ts: Date.now() })); } catch (e) {} }
  function fmtN(n, fr) { return n.toLocaleString(fr ? 'fr-CA' : 'en-CA'); }
  function roundDown(n) { return n >= 1000 ? Math.floor(n / 50) * 50 : Math.floor(n / 10) * 10; }

  function applyEverywhere(s, fr) {
    if (document.querySelector('[data-ww-review-count][data-authoritative="1"]')) return;
    if (s.total) {
      [].forEach.call(document.querySelectorAll('[data-ww-review-count]'), function (el) {
        var mode = el.getAttribute('data-ww-review-count');
        if (mode === 'plus') el.textContent = fmtN(roundDown(s.total), fr) + '+';
        else if (mode === 'label') el.textContent = '(' + fmtN(s.total, fr) + ' ' + (fr ? 'avis' : 'reviews') + ')';
        else if (mode === 'paren') el.textContent = '(' + fmtN(s.total, fr) + ')';
        else el.textContent = fmtN(s.total, fr);
      });
    }
    if (s.rating) {
      [].forEach.call(document.querySelectorAll('[data-ww-review-rating]'), function (el) { el.textContent = s.rating.toFixed(1); });
      [].forEach.call(document.querySelectorAll('[data-ww-review-stars] .ww-stars__fill'), function (el) { el.style.width = (s.rating * 20) + '%'; });
    }
  }

  function applySummary(block, s, fr) {
    if (s.rating) {
      var el = block.querySelector('[data-rv-rating]'); if (el) el.textContent = s.rating.toFixed(1);
      var fill = block.querySelector('.ww-rv__stars .ww-stars__fill'); if (fill) fill.style.width = (s.rating * 20) + '%';
    }
    if (s.total) {
      var t = block.querySelector('[data-rv-total]');
      if (t) t.textContent = (fr ? 'sur ' : 'from ') + fmtN(s.total, fr) + (fr ? ' avis Google' : ' Google reviews');
      var title = block.querySelector('[data-rv-title]');
      if (title) title.textContent = fr ? 'Plus de ' + fmtN(roundDown(s.total), fr) + ' avis Google' : 'Over ' + fmtN(roundDown(s.total), fr) + ' Google reviews';
    }
    applyEverywhere(s, fr);
  }

  function boot(block) {
    if (block.__ww) return; block.__ww = true;
    var fr = block.getAttribute('data-lang') === 'fr';
    var raw = block.querySelector('[data-rv-raw]');
    var mount = raw && raw.querySelector('.romw-reviews');
    var src = block.getAttribute('data-src');
    if (!mount || !src) { fallback(); return; }

    /* load the widget script (once per page) */
    if (!document.querySelector('script[src="' + src + '"]')) {
      var s = document.createElement('script'); s.src = src; s.async = true; document.body.appendChild(s);
    }

    var started = Date.now(), done = false;
    function attempt() {
      if (done) return;
      var reviews = extract(mount);
      if (reviews.length) {
        done = true;
        useSummary(readSummary(mount));
        render(block, reviews, fr);
        return;
      }
      if (Date.now() - started > 10000) { done = true; fallback(); }
    }
    var authoritative = block.getAttribute('data-authoritative') === '1';
    function useSummary(sum) {
      debug(mount, sum);
      if (!sum.total && !sum.rating) return;
      writeCache(sum);
      /* numbers from the shop metafield (Google Places, refreshed daily) beat whatever the widget prints */
      if (!authoritative) applySummary(block, sum, fr);
    }
    function fallback() {
      block.classList.add('is-fallback'); if (raw) raw.hidden = false;
      useSummary(readSummary(mount));
    }
    /* the summary line often renders later than the cards: re-read it a few times after we're done */
    var later = 0, laterT = setInterval(function () {
      if (++later > 12) { clearInterval(laterT); return; }
      var c = readCache(); if (c && c.total) { clearInterval(laterT); return; }
      useSummary(readSummary(mount));
    }, 1500);

    /* the widget renders asynchronously and may re-render; keep looking until it settles */
    var obs = new MutationObserver(function () { clearTimeout(obs._t); obs._t = setTimeout(attempt, 300); });
    obs.observe(mount, { childList: true, subtree: true, characterData: true });
    var poll = setInterval(function () { attempt(); if (done) { clearInterval(poll); obs.disconnect(); } }, 800);
  }

  function init() {
    var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
    var blocks = [].slice.call(document.querySelectorAll('[data-ww-reviews]'));
    /* last known numbers first, so the tab label / headline are right before the widget even loads */
    var cached = readCache();
    var authoritative = document.querySelector('[data-ww-reviews][data-authoritative="1"], [data-ww-review-count][data-authoritative="1"]');
    if (cached && !authoritative) {
      applyEverywhere(cached, fr);
      blocks.forEach(function (b) { applySummary(b, cached, b.getAttribute('data-lang') === 'fr'); });
    }
    if (DEBUG) console.log('[ww-reviews] blocks:', blocks.length, 'cached:', cached, 'authoritative:', !!authoritative);
    if (!blocks.length) return;
    if (!('IntersectionObserver' in window)) { blocks.forEach(boot); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { boot(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '400px 0px' });
    blocks.forEach(function (b) { io.observe(b); });
    /* No idle pre-load of the Google widget any more: its script injects page-wide CSS and caused a layout
       shift a couple of seconds after load on the PDP. The review count now comes from
       shop.metafields.custom.google_reviews (Mechanic task); the widget itself loads only when its block is
       actually scrolled into view (home page) or its tab is opened (PDP). */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
